// Discontinued institutions are capped at max_academic_year (+ max_academic_semester)
// and can't create data beyond it - the backend enforces this (Institution::allowsAcademicTerm),
// this just hides the blocked years from the shared dropdown lists defined in main.js.

import Vue from "vue";

const originals = {};

// same rules as the backend: years compare as text ("2025-26"), odd comes before even
export function allowsAcademicTerm(institution, year, semester = null) {
  const maxYear = institution && institution.max_academic_year;
  if (!maxYear || !year || year === "0") return true;
  if (year !== maxYear) return year < maxYear;
  return !(institution.max_academic_semester === "odd" && semester === "even");
}

// filters the global lists in place, so every component reading them gets the capped version
export function applyAcademicYearCap(institution) {
  const lists = {
    $settingAcedemicYearsAndSemester: (option) =>
      !option.value || allowsAcademicTerm(institution, option.value[0], option.value[1]),
    $acedemicYears: (option) => !option.value || allowsAcademicTerm(institution, option.value),
  };

  Object.keys(lists).forEach((key) => {
    const list = Vue.prototype[key];
    if (!originals[key]) originals[key] = list.slice();
    list.splice(0, list.length, ...originals[key].filter(lists[key]));
  });
}
